import React from 'react';
import porject12 from '../../image/project12.png';
import porject11 from '../../image/project11.png';
import porject10 from './../../image/project10.png';
import porject9 from '../../image/project9.png';
import { Link } from 'react-router-dom';

const Projects = () => {
    return (
        <div>
            <h1 className='text-3xl text-center font-bold pb-20'>My Projects</h1>
            <div>
                <div class=" container mx-auto grid grid-cols-1 2xl:grid-cols-3 xl:grid-cols-3  lg:grid-cols-3 md:grid-cols-2 gap-4">
                <div class="card w-96 bg-base-100 shadow-xl">
                        <figure><img src={porject12} alt="Motor-parts" /></figure>
                        <div class="card-body">
                            <h2 class="card-title">
                            Motor Parts Manufacturer
                                <div class="badge badge-secondary">FullStack</div>
                            </h2>
                            <p>If a dog chews shoes whose shoes does he choose?</p>
                            <div class="card-actions justify-end">
                          <Link to='/motor-parts-manufacturer' className='btn btn-primary'>Project Details</Link>
                            </div>
                        </div>
                    </div>
                    <div class="card w-96 bg-base-100 shadow-xl">
                        <figure><img src={porject11} alt="Shoes" /></figure>
                        <div class="card-body">
                            <h2 class="card-title">
                            Ent WareHouse
                                <div class="badge badge-secondary">Full-Stack</div>
                            </h2>
                            <p>If a dog chews shoes whose shoes does he choose?</p>
                            <div class="card-actions justify-end">
                               <Link to='/ent-warehouse' className='btn btn-primary'>Project Details</Link>
                            </div>
                        </div>
                    </div>
                    <div class="card w-96 bg-base-100 shadow-xl">
                        <figure><img src={porject10} alt="Shoes" /></figure>
                        <div class="card-body">
                            <h2 class="card-title">
                               Solo Traveller
                                <div class="badge badge-secondary">Full-Stack</div>
                            </h2>
                            <p>If a dog chews shoes whose shoes does he choose?</p>
                            <div class="card-actions justify-end">
                               <Link to='/solo-traveller' className='btn btn-primary'>Project Details</Link>
                            </div>
                        </div>
                    </div>
                    
                    {/* <div class="card w-96 bg-base-100 shadow-xl">
                        <figure><img src={porject9} alt="Shoes" /></figure>
                        <div class="card-body">
                            <h2 class="card-title">
                                Gamers Pulse
                                <div class="badge badge-secondary">Front-End</div>
                            </h2>
                            <p>If a dog chews shoes whose shoes does he choose?</p>
                            <div class="card-actions justify-end">
                                <button class="btn btn-primary"><Link to='/gamers-pulse'>Project Details</Link></button>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default Projects;